export default {
  recentOrders: {
    mostRecentOrders: 'Most recent orders',
    viewAllOrders: 'View All Orders',
    printLabel: 'Print Label',
    getALabel: 'Get a Label',
    addTracking: 'Add Tracking',
  },
};
